<div class="member-timeline-container">
  <div *ngIf="timelineLoading" class="member-timeline-status">Loading...</div>
  <app-timeline-detail *ngIf="!timelineLoading && timelineGroups.size" [timeline]="timelineGroups"></app-timeline-detail>
  <div *ngIf="!timelineLoading && timelineLoaded && !timelineGroups.size" class="member-timeline-status">
    No history available.
  </div>
</div>
